import { Component, OnInit,  } from '@angular/core';
import {  ActivatedRoute, Router } from '@angular/router';
declare var $: any;
import * as _ from 'lodash';
import { Sh6Service } from 'src/app/services/sh6.service';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { AlertComponent } from '../../alert/alert.component';
@Component({
  selector: 'app-sh6',
  templateUrl: './sh6.component.html',
  styleUrls: ['./sh6.component.css']
})
export class Sh6Component implements OnInit {

  shForm: FormGroup;
  shList: any[];
  restrictTabflag: boolean;
  editParticularId: any;
  editParticularData: any;
  dateOfSpecialResolutionModel: { month: number; day: number; year: number; };
  dateOnWhichOptionsVestedModel: { month: number; day: number; year: number; };
  dateOnWhichOptionsExcercisedModel: { month: number; day: number; year: number; };
  TodayDate: NgbDateStruct;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  disabledOnClick: boolean;

   constructor(private Sh6Service: Sh6Service,
    private activatedRoute: ActivatedRoute,
    private alert: AlertComponent,
    private router: Router) { }

  ngOnInit() {
    this.shForm = new FormGroup({
      
      dateOfSpecialResolution: new FormControl('', [Validators.required]),
      nameOfTheGrantee: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z ,.'&-]*$"), Validators.maxLength(200)]),
      numberOfOptionsGranted: new FormControl('', [Validators.required, Validators.pattern("^[0-9 ,.'-/]*$"), Validators.maxLength(100)]),
      dateOnWhichOptionsVested: new FormControl('', []),
      excercisePeriod: new FormControl('', [Validators.required, Validators.pattern("^[0-9 ,.'&-]*$"), Validators.maxLength(200)]), 
      dateOnWhichOptionsExcercised: new FormControl('', []),
      optionsexcercised: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ,.'&/-]*$"), Validators.maxLength(1000)]),
      excercisePrice: new FormControl('', [Validators.pattern("^[0-9 ,.'-]*$"), Validators.maxLength(200)]),
      numberOfSharesArisingAsResultOfExcerciseOfOption: new FormControl('', [Validators.pattern("^[0-9 ,.'-]*$"), Validators.maxLength(200)]),
      folioNumberOfRegisterOfMembersHavingRespectiveEntry: new FormControl('', [Validators.required, Validators.pattern("^[a-zA-Z0-9 ,.'/-]*$"), Validators.maxLength(100)]),
      lockInPeriod: new FormControl('', [Validators.pattern("^[0-9 ,.'-]*$"),Validators.maxLength(100)]),
      optionLapsed: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 ,.'&/-]*$"), Validators.maxLength(1000)]),
      totalNumberOfOptionsInForce: new FormControl('', [Validators.pattern("^[0-9 ,.'-]*$"), Validators.maxLength(100)]),
      amountForteitedIfOptionIsNotExcecuted: new FormControl('', [Validators.pattern("^[0-9 ,.'-/]*$"), Validators.maxLength(200)]),
      anyVariationOfTermsOfTheSchemeAndItsEffects: new FormControl('', [Validators.pattern("^[a-zA-Z0-9 .,&'*\n-]*$"), Validators.maxLength(250)])
    });

    this.activatedRoute.params.subscribe(params => {
      if (params['particularId'] != undefined) {
        this.restrictTabflag = true;
        this.editParticularId = params['particularId'];
        this.getSh6ById(this.editParticularId);
      } else {
        this.restrictTabflag = false;
      }
    })
    
  }
  
  back(){
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['sh6list']  } }],
      { relativeTo: this.activatedRoute.parent });
  }
  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }
  noBlankSpaceAtStart(ev) {
    if (ev.which === 32 && ev.target.selectionStart === 0) {
      return false;
    }
  } 
  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }
  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  showFormEntry() {
    this.disabledOnClick = true;
    var object = {

      dateOfSpecialResolution: this.setDate(this.shForm.controls.dateOfSpecialResolution.value),
      nameOfTheGrantee: this.shForm.controls.nameOfTheGrantee.value,
      numberOfOptionsGranted: this.shForm.controls.numberOfOptionsGranted.value,
      dateOnWhichOptionsVested: this.setDate(this.shForm.controls.dateOnWhichOptionsVested.value),
      excercisePeriod: this.shForm.controls.excercisePeriod.value,
      dateOnWhichOptionsExcercised: this.setDate(this.shForm.controls.dateOnWhichOptionsExcercised.value),
      optionsexcercised: this.shForm.controls.optionsexcercised.value,
      excercisePrice: this.shForm.controls.excercisePrice.value,
      numberOfSharesArisingAsResultOfExcerciseOfOption: this.shForm.controls.numberOfSharesArisingAsResultOfExcerciseOfOption.value,
      folioNumberOfRegisterOfMembersHavingRespectiveEntry: this.shForm.controls.folioNumberOfRegisterOfMembersHavingRespectiveEntry.value,
      lockInPeriod: this.shForm.controls.lockInPeriod.value,
      optionLapsed: this.shForm.controls.optionLapsed.value,
      totalNumberOfOptionsInForce: this.shForm.controls.totalNumberOfOptionsInForce.value,
      amountForteitedIfOptionIsNotExcecuted: this.shForm.controls.amountForteitedIfOptionIsNotExcecuted.value,
      anyVariationOfTermsOfTheSchemeAndItsEffects: this.shForm.controls.anyVariationOfTermsOfTheSchemeAndItsEffects.value,
    }

    
    this.Sh6Service.sampleShRecord(object).subscribe(response => {
      this.disabledOnClick = false;
      if (response.status == 0) {
        this.restrictTabflag = true;
        this.alert.successWithOk(response.message, 'sh6list');
      } else {
        this.restrictTabflag = false;
       
        if(response.err_fields){
        this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }
        else{
         this.alert.error(response.message);
        }
        
      }
    })
    
  }

  getSh6ById(particularId) {
    this.Sh6Service.updatesh6(particularId).subscribe(response => {
      
      this.editParticularData = response.data[0];
      this.shForm.controls.dateOfSpecialResolution.setValue(this.editParticularData.dateOfSpecialResolution);
      this.shForm.controls.nameOfTheGrantee.setValue(this.editParticularData.nameOfTheGrantee);
      this.shForm.controls.numberOfOptionsGranted.setValue(this.editParticularData.numberOfOptionsGranted);
      this.shForm.controls.dateOnWhichOptionsVested.setValue(this.editParticularData.dateOnWhichOptionsVested);
      this.shForm.controls.excercisePeriod.setValue(this.editParticularData.excercisePeriod);
      this.shForm.controls.dateOnWhichOptionsExcercised.setValue(this.editParticularData.dateOnWhichOptionsExcercised);
      this.shForm.controls.optionsexcercised.setValue(this.editParticularData.optionsexcercised);
      this.shForm.controls.excercisePrice.setValue(this.editParticularData.excercisePrice);
      this.shForm.controls.numberOfSharesArisingAsResultOfExcerciseOfOption.setValue(this.editParticularData.numberOfSharesArisingAsResultOfExcerciseOfOption);
      this.shForm.controls.folioNumberOfRegisterOfMembersHavingRespectiveEntry.setValue(this.editParticularData.folioNumberOfRegisterOfMembersHavingRespectiveEntry);
      this.shForm.controls.lockInPeriod.setValue(this.editParticularData.lockInPeriod);
      this.shForm.controls.optionLapsed.setValue(this.editParticularData.optionLapsed);
      this.shForm.controls.totalNumberOfOptionsInForce.setValue(this.editParticularData.totalNumberOfOptionsInForce);
      this.shForm.controls.amountForteitedIfOptionIsNotExcecuted.setValue(this.editParticularData.amountForteitedIfOptionIsNotExcecuted);
      this.shForm.controls.anyVariationOfTermsOfTheSchemeAndItsEffects.setValue(this.editParticularData.anyVariationOfTermsOfTheSchemeAndItsEffects);

      if (this.editParticularData.dateOfSpecialResolution != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOfSpecialResolution));
        this.dateOfSpecialResolutionModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateOnWhichOptionsVested != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOnWhichOptionsVested));
        this.dateOnWhichOptionsVestedModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }
      if (this.editParticularData.dateOnWhichOptionsExcercised != null) {
        let dt = new Date(this.setFormatDate(this.editParticularData.dateOnWhichOptionsExcercised));
        this.dateOnWhichOptionsExcercisedModel = { month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() };
      }

    });
  }

  updateSh6() {
    this.disabledOnClick = true;
    var object = {
      dateOfSpecialResolution: this.setDate(this.dateOfSpecialResolutionModel),
      nameOfTheGrantee: this.shForm.controls.nameOfTheGrantee.value,
      numberOfOptionsGranted: this.shForm.controls.numberOfOptionsGranted.value,
      dateOnWhichOptionsVested: this.setDate(this.dateOnWhichOptionsVestedModel),
      excercisePeriod: this.shForm.controls.excercisePeriod.value,
      dateOnWhichOptionsExcercised: this.setDate(this.dateOnWhichOptionsExcercisedModel),
      optionsexcercised: this.shForm.controls.optionsexcercised.value,
      excercisePrice: this.shForm.controls.excercisePrice.value,
      numberOfSharesArisingAsResultOfExcerciseOfOption: this.shForm.controls.numberOfSharesArisingAsResultOfExcerciseOfOption.value,
      folioNumberOfRegisterOfMembersHavingRespectiveEntry: this.shForm.controls.folioNumberOfRegisterOfMembersHavingRespectiveEntry.value,
      lockInPeriod: this.shForm.controls.lockInPeriod.value,
      optionLapsed: this.shForm.controls.optionLapsed.value,
      totalNumberOfOptionsInForce: this.shForm.controls.totalNumberOfOptionsInForce.value,
      amountForteitedIfOptionIsNotExcecuted: this.shForm.controls.amountForteitedIfOptionIsNotExcecuted.value,
      anyVariationOfTermsOfTheSchemeAndItsEffects: this.shForm.controls.anyVariationOfTermsOfTheSchemeAndItsEffects.value,
    }
    this.Sh6Service.updateSh6(object, this.editParticularId).subscribe(response => {
      this.disabledOnClick = false;
      if (response.status == 0) {
        this.alert.successWithOk(response.message, 'sh6list');
      } else {
       
        if(response.err_fields){
        this.alert.error( JSON.stringify(response.err_fields) + 'fields are required or invalid.');
        }
        else{
          this.alert.error(response.message);
        }
      }

    });
  }

  generateOutput() {
    var object = {
      id: this.editParticularId,
      fromDate: null,
      toDate: null
    }
    this.Sh6Service.generateSh6Document(object).subscribe(response => {
      if (response.status == 0) {
        this.alert.success(response.message);
        var self = this;
        setTimeout(function () {
          self.downloadDocument(self.editParticularId);
          setTimeout(function () {
            self.downloadPdfDocument(self.editParticularId);
          }, 1000);
        }, 1000);
      } else {
        this.alert.error(response.message);
      }
    })
  }
  
  downloadDocument(id) {
    this.Sh6Service.downloadSh6File(id, 'Single');
  }
  downloadPdfDocument(id) {
    this.Sh6Service.downloadSh6PdfFile(id, 'Single');
  }
}

